/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_Th_IdentityInputs */

const tr_kvkkbasvuru_s2_th_identity = /** @type {(inputs: Kvkkbasvuru_S2_Th_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerekli Kimlik Doğrulama`)
};

const en_kvkkbasvuru_s2_th_identity = /** @type {(inputs: Kvkkbasvuru_S2_Th_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required Identity Verification`)
};

const de_kvkkbasvuru_s2_th_identity = /** @type {(inputs: Kvkkbasvuru_S2_Th_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderliche Identitätsprüfung`)
};

const ru_kvkkbasvuru_s2_th_identity = /** @type {(inputs: Kvkkbasvuru_S2_Th_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуемое подтверждение личности`)
};

/**
* | output |
* | --- |
* | "Required Identity Verification" |
*
* @param {Kvkkbasvuru_S2_Th_IdentityInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_th_identity = /** @type {((inputs?: Kvkkbasvuru_S2_Th_IdentityInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_Th_IdentityInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_th_identity(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_th_identity(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_th_identity(inputs)
	return tr_kvkkbasvuru_s2_th_identity(inputs)
});